import React from 'react'
// libs
import styled from 'styled-components'
import { useMutation } from '@apollo/client/react'
import { InjectedFormProps, reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxEntitySelect } from 'components/FormElements/ReduxForm'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'
// constants
import { Forms } from 'constants/index'
// graphql
import { OBJECT_SECURITIES_QUERY } from 'graphql/objectSecurity/queries'
import { OBJECT_ENTITY_UPDATE_MUTATION } from 'graphql/objects/mutations'
// types
import { IOption } from 'components/FormElements/Select'
// utils
import { objectSecurityProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const Form = styled('form')`
  padding-bottom: 24px;
  width: 100%;
`

interface FormData {
  ownerObjectSecurity: IOption
  memberObjectSecurity: IOption
}

const ObjectSecurityForm: React.FC<InjectedFormProps<FormData>> = ({ handleSubmit }) => {
  const [objectEntityUpdateMutation] = useMutation(OBJECT_ENTITY_UPDATE_MUTATION)

  const { object } = React.useContext(ObjectsAPIContext)

  const onSelectChange = async (data, input) => {
    await objectEntityUpdateMutation({
      variables: {
        id: object.id,
        input: {
          [`${input.name}Id`]: data.value
        }
      }
    })
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container justifyContent={'space-between'} spacing={2}>
        <Grid size={6}>
          <ReduxEntitySelect
            label={`${object.name} Owner Security Assignment`}
            name={'ownerObjectSecurity'}
            onSelectChange={onSelectChange}
            query={OBJECT_SECURITIES_QUERY}
            variables={{
              filter: {
                objectEntityApiName: object.apiName
              }
            }}
            {...objectSecurityProps}
          />
        </Grid>
        <Grid size={6}>
          <ReduxEntitySelect
            label={`Default ${object.name} Member Security Assignment`}
            name={'memberObjectSecurity'}
            onSelectChange={onSelectChange}
            query={OBJECT_SECURITIES_QUERY}
            variables={{
              filter: {
                objectEntityApiName: object.apiName
              }
            }}
            {...objectSecurityProps}
          />
        </Grid>
      </Grid>
    </Form>
  )
}

export default reduxForm<FormData>({
  form: Forms.OBJECT_SECURITY_FORM,
  enableReinitialize: true
})(ObjectSecurityForm)
